
export default function UrgencyIncentiveSection() {
  return (
    <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-white/20 rounded-full p-4">
              <i className="ri-lightbulb-line text-white text-3xl"></i>
            </div>
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            Knowledge is Power - And It Pays
          </h2>
          
          <p className="text-xl text-blue-100 mb-2 max-w-2xl mx-auto">
            <strong>Smart homeowners get quotes first.</strong> Whether you're starting next month or planning for next year, knowing your true project costs gives you a huge advantage.
          </p>
          
          <p className="text-lg text-blue-200 mb-8 max-w-2xl mx-auto">
            <i className="ri-shield-line text-blue-300 mr-1"></i>
            Plus, you'll be protected from contractor surprises and overcharging when you're ready to move forward.
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm border-2 border-green-400">
              <div className="text-3xl font-bold text-green-300 mb-2">$1,750 OFF</div>
              <div className="text-blue-100 text-sm font-semibold">
                <i className="ri-calculator-line mr-1"></i>
                Quote within 48 hours
              </div>
              <div className="text-xs text-green-200 mt-1">Fast info + best savings!</div>
            </div>
            
            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm border border-blue-300">
              <div className="text-2xl font-bold text-white mb-2">$1,250 OFF</div>
              <div className="text-blue-100 text-sm">
                <i className="ri-calendar-line mr-1"></i>
                Quote within this week
              </div>
              <div className="text-xs text-blue-200 mt-1">Great planning reward!</div>
            </div>
            
            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm border border-gray-300">
              <div className="text-2xl font-bold text-white mb-2">$1,000 OFF</div>
              <div className="text-blue-100 text-sm">
                <i className="ri-search-line mr-1"></i>
                Just exploring options
              </div>
              <div className="text-xs text-blue-200 mt-1">Smart planning pays!</div>
            </div>
          </div>
          
          <div className="bg-white/10 rounded-xl p-6 mb-6 border border-white/20">
            <h3 className="text-xl font-bold text-white mb-4">🎯 WHAT YOUR FREE QUOTE INCLUDES:</h3>
            <div className="grid md:grid-cols-2 gap-4 text-left">
              <div className="flex items-start space-x-3">
                <i className="ri-file-text-line text-blue-400 text-xl mt-1"></i>
                <div className="text-white">
                  <strong>Detailed cost breakdown</strong> - know exactly where your money goes
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-calendar-line text-green-400 text-xl mt-1"></i>
                <div className="text-white">
                  <strong>Project timeline</strong> - plan around your schedule
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-tools-line text-purple-400 text-xl mt-1"></i>
                <div className="text-white">
                  <strong>Material recommendations</strong> - quality options for your budget
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-shield-check-line text-yellow-400 text-xl mt-1"></i>
                <div className="text-white">
                  <strong>Licensed contractor matches</strong> - verified and trusted professionals
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-green-100/20 to-blue-100/20 rounded-xl p-4 mb-6">
            <p className="text-white font-semibold">
              <i className="ri-lightbulb-line mr-2 text-yellow-300"></i>
              Pro Tip: Even if you're not ready to start, getting a quote now helps you budget properly and avoid contractor surprises later!
            </p>
          </div>
          
          <div className="text-blue-100 text-sm">
            <i className="ri-map-pin-line mr-1"></i>
            Connecticut residents only. All planning timelines welcome - from "ready now" to "maybe next year."
          </div>
        </div>
      </div>
    </section>
  );
}
